import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { App as AntdApp, ConfigProvider as AntdConfig } from 'antd';
import AntdUtils from '@/components/Common/AntdUtils';
import RouteBeforeEach from '@/router/helpers/RouteBeforeEach';
import { isMobileDevice } from '@/utils/device';
import { useRouteStore } from '@/store/route';
import en_US from 'antd/locale/en_US';
import ErrorBoundaryCom from '@/components/ErrorBoundaryCom';
import { useTerminalTypeStore } from '@/store/terminal-type';
import SiteFooter from '@/components/SiteFooter';
import useRevealMotion from '@/hooks/useRevealMotion';
import '@/assets/scss/common.scss';
import { useLocation } from 'react-router-dom';

const App = () => {
  const { flatRoutes } = useRouteStore();
  const { setIsMobile } = useTerminalTypeStore();
  const location = useLocation();

  useRevealMotion(location.pathname);

  useEffect(() => {
    const onResize = () => setIsMobile(isMobileDevice());
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [setIsMobile]);

  return (
    <ErrorBoundaryCom>
      <AntdApp>
        <AntdConfig locale={en_US}>
          <AntdUtils>
            <Routes>
              {flatRoutes.map(route => (
                <Route
                  key={route.fullPath}
                  path={route.fullPath}
                  element={<RouteBeforeEach route={route} />}
                />
              ))}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <SiteFooter />
          </AntdUtils>
        </AntdConfig>
      </AntdApp>
    </ErrorBoundaryCom>
  );
};

export default App;
